module.exports = __webpack_public_path__ + "7a0571832aa4742925f46006d14c8369.png";